import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';
/**
 * @ngModule SharedModule
 * @whatItDoes Displays the appropriate time zone abbreviation (EST/EDT) for a given date.
 */
@Pipe({
  name: 'estName'
})
export class EstNamePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private readonly _locale: string) {
    moment.locale(_locale);
  }

  /**
   * Transform operator of the pipe.
   */
  transform(value: any): string {
    const time = moment.tz(value, 'America/New_York');

    return time.format('z');
  }
}
